import React from 'react'
import './index.scss'

import sloganPng from './img/f-logo.png'
import downloadPng from './img/foot-download.png'
import footevmPng from './img/foot-ewm.png'
import ghPng from './img/icon-gh.png'

const FootBar = (props) => {
    return (
        <div className="FootBar">
            <div className="foot-m clearfix">
                <img src={sloganPng} className="fl f-logo" alt="58钱柜slogan" />
                <img src={downloadPng} className="f-dl" alt="58钱柜二维码" />
                <img src={footevmPng} className="f-wx" alt="58钱柜二维码" />
                <div className="foot-kefu fr tl">
                    <p>客服热线：10105800 （周一到周日  9：00-18：00）</p>
                    <p>地址：北京市朝阳区酒仙桥北路甲10号院105号楼</p>
                </div>
                <div className="footer-b">
                    <div className="copyright gray">
                        <p>版权所有 Copyright©{(new Date().getFullYear())} 北京五八钱柜信息技术有限公司 <a className="register-link" rel="noopener noreferrer" target="_blank" href="https://beian.miit.gov.cn">京ICP备15058212号</a></p>
                        <p>电信与信息服务业务经营许可证京ICP证151153号</p>
                    </div>
                    <div className="bj-net-safe">
                        <a className="register-link" rel="noopener noreferrer" target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502033643 ">
                            <img src={ghPng} alt="国徽" /><span className="gray">&nbsp;&nbsp;京公网安备11010502033643号</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FootBar;



// WEBPACK FOOTER //
// ./src/components/FootBar/index.js